import React from 'react'
import './loader.css'

const Loader = () => {
  return (
    <div class="spinner-square">
        <div class="square-1 square"></div>
        <div class="square-2 square"></div>
        <div class="square-3 square"></div>
</div>
  )
}

export default Loader
